import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import { size } from 'lodash';
import {IAppValidator} from './validator';

export const minLengthErrorKey = 'minLengthErrorKey';
export const maxLengthErrorKey = 'maxLengthErrorKey';
export const minValueErrorKey = 'minValueErrorKey';
export const maxValueErrorKey = 'maxValueErrorKey';

export class MinLengthValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control?.value ?? null;

      if (value){
        if (size(value) < configurationValue){
          return {[minLengthErrorKey]: `Tamanho menor que o mínimo permitido (${configurationValue})`};
        }
      }

      return {};
    };
  }
}

export class MaxLengthValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control?.value ?? null;

      if (value){
        if (size(value) > configurationValue){
          return {[maxLengthErrorKey]: `Tamanho maior que o máximo permitido (${configurationValue})`};
        }
      }

      return {};
    };
  }
}

export class MinValueValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control?.value ?? null;

      if (value){
        if (+value < +configurationValue){
          return {[minValueErrorKey]: `Tamanho menor que o mínimo permitido (${configurationValue})`};
        }
      } else {
        return {[minValueErrorKey]: `Tamanho inválido`};
      }

      return {};
    };
  }
}

export class MaxValueValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control?.value ?? null;

      if (value){
        if (+value > +configurationValue){
          return {[maxValueErrorKey]: `Tamanho maior que o máximo permitido (${configurationValue})`};
        }
      } else {
        return {[maxValueErrorKey]: `Tamanho inválido`};
      }

      return {};
    };
  }
}

export const minLengthValidator = new MinLengthValidator();
export const maxLengthValidator = new MaxLengthValidator();
export const minValueValidator = new MinValueValidator();
export const maxValueValidator = new MaxValueValidator();
